import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    name: "login",
    path: "/login",
    component: () => import("@/views/login/index.vue"),
  },
  {
    name: "register",
    path: "/register",
    component: () => import("@/views/accountRegister/index.vue"),
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("@/views/profile/index.vue"),
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("@/views/admin/index.vue"),
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('@/views/home/index.vue'),
    children: [
      {
        path: '',
        name: 'list',
        component: () => import('@/views/home/components/list/index.vue'),
      },
      {
        path: 'watchEdit/:id?',
        name: 'editor',
        component: () => import('@/views/home/components/edit/index.vue'),
      },
    ],
  },
];

export default routes;
